import React, { useState, useEffect, useRef } from "react";
import Radio from "@material-ui/core/Radio";
import {  Card, Dropdown } from 'react-bootstrap';
import { useDispatch,  useSelector } from "react-redux";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import api from '~/services/api';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import {
  ContainerType,
  CardType,
  ItemCard,
  AlignDropdownBranch,
  Select,
  AlignItens,
  CardTypeLeft,
  CardTypeRight
} from "./styles";
import { CardHeader } from "~/pages/Order/styles";
import "~/components/styles/Global.css";

import TruckIcon from '~/assets/images/truck-blue.svg';
import CalendarIcon from '~/assets/images/calendar.svg';
import MapIcon from '~/assets/images/map.svg';
import Datepicker from "~/components/layout/Logistic/DatepickerField";
import useOutsideClickDropdown from "~/hooks/useOutsideClickDropdown";

const mapperServiceType = {
  RETIRA: 'RETIRA',
  ENTREGA: 'ENTREGA'
}

export default function OrderSelect({ servicesTypes, filiais, setSelectedBranch, setSelectedTypes, setLoadingConfirm, loadingConfirm }) {
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const logisticReducer = useSelector(state => state.logisticReducer);
  const history = useHistory();
  const [selectDeliveryType, setSelectDeliveryType] = useState(
    logisticReducer.deliveryType ? logisticReducer.deliveryType  : servicesTypes[0]
  );
  const [expand, setExpand] = useState(false);
  const [expandAffiliate, setExpandAffiliate] = useState(false);
  const [selectAffiliateyType, setSelectAffiliateType] = useState(filiais[logisticReducer.selectedBranch]);
  const [selectAffiliateyIndex, setSelectAffiliateIndex] = useState(logisticReducer.selectedBranch);

  const getRetainedStores  = async () => {
    setLoadingConfirm(true)
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    const customerId = logisticReducer?.business ? logisticReducer.business.customerId : null;
    const siteUseId = logisticReducer?.business ? logisticReducer.business.siteUseId : null;

    await api
      .get(`/residential/store/v1/retained-stores?customer_id=${customerId}&site_use_id=${siteUseId}`, parameters)
      .then(async (response) => {
        if (response.data.hold === 'Y') {
            toast.error('Identificamos a necessidade de atualizações em seu cadastro, contate o seu consultor para regularização.');
            setTimeout(() => {
              setLoadingConfirm(false)
              history.push('/portal');
            }, 1500);
        }
        setLoadingConfirm(false)
      })
      .catch(err => {
        console.log('err => ', err);
        setLoadingConfirm(false)
      });
  }

  useEffect(() => {
    
    if (logisticReducer?.business) {
        getRetainedStores()
    }

  }, []);

  useOutsideClickDropdown(dropdownRef, setExpand);
  useOutsideClickDropdown(dropdownRef, setExpandAffiliate);

  useEffect(() => {
    setSelectedBranch(selectAffiliateyIndex);
  }, [selectAffiliateyIndex]);

  useEffect(() => {
    setSelectedTypes(selectDeliveryType);
  }, [selectDeliveryType]);

  const CustomSelect = React.forwardRef(({ children, onClick }, ref) => {
    return (
      <Select
        ref={ref}
        onClick={event => {
          event.preventDefault();
          onClick(event);
          expand ? setExpand(false) : setExpand(true);
        }}
      >
        <span style={{ fontSize: '0.7rem',  margin: '0.6rem 0rem' }}>{children}</span>
        {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Select>
    );
  });

  const CustomSelectAffiliate = React.forwardRef(({ children, onClick}, ref) => {
    return (
      <Select
        ref={ref}
        onClick={event => {
          event.preventDefault();
          onClick(event);
          expandAffiliate ? setExpandAffiliate(false) : setExpandAffiliate(true);
        }}
      >
        <span style={{ fontSize: '0.7rem',  margin: '0.5rem 0rem' }}>{children}</span>
        {expandAffiliate ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Select>
    );
  });

  return (
    <div>
       <ContainerType>
        <CardType>
          <Card.Header style={CardHeader}>Filial abastecedora</Card.Header>
          <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', boxShadow: '0px 2px 4px #00000033' }}>
            <>
              <ItemCard>
                <img className="order-icon-map" src={MapIcon} alt="Ícone de retirada de pedido" />
                <Dropdown className="branch" id="affiliate" ref={dropdownRef}>
                  <Dropdown.Toggle
                    as={CustomSelectAffiliate}                    
                  >
                    {selectAffiliateyType?.name ? selectAffiliateyType.name : '' }
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ maxHeight: '120px', overflowY: 'auto'  }}>
                    {filiais.map((element, index) => {
                      return (
                        <Dropdown.Item
                          key={element.id}
                          eventKey={element.id}
                          disabled={loadingConfirm}
                          onClick={() => {
                            setSelectAffiliateType(element);
                            setSelectAffiliateIndex(index);
                            dispatch({
                              type: 'SELECT_BRANCH_LOGISTIC',
                              selectedBranch: index
                            });
                          }}
                          style={AlignDropdownBranch}
                        >
                          <AlignItens >
                            <Radio
                              color="primary"
                              checked={
                                selectAffiliateyType?.id === element.id
                              }
                            />
                            <span className="product" style={{ fontSize: '0.7rem' }}>
                              {element.name}
                            </span>
                          </AlignItens>
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </ItemCard>
            </>
          </Card>
        </CardType>
      </ContainerType>
      <ContainerType>
        <CardTypeLeft>
          <Card.Header style={CardHeader}>Tipo de pedido</Card.Header>
          <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', boxShadow: '0px 2px 4px #00000033' }}>
            <>
              <ItemCard>
                <img src={TruckIcon} alt="Ícone de retirada de pedido" />
                <Dropdown className="delivery" id="delivery" ref={dropdownRef}>
                  <Dropdown.Toggle
                    as={CustomSelect}
                  >
                    {mapperServiceType[selectDeliveryType]}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {servicesTypes.map((element) => {
                      return (
                        <Dropdown.Item
                          key={element}
                          eventKey={element}
                          disabled={loadingConfirm}
                          onClick={() => {
                            setSelectDeliveryType(element);
                          }}
                          style={AlignDropdownBranch}
                        >
                          <AlignItens>
                            <Radio
                              color="primary"
                              checked={
                                selectDeliveryType === element
                              }
                            />
                            <span className="product" style={{ fontSize: '0.7rem',  margin: '0.6rem 1rem' }}>
                              {mapperServiceType[element]}
                            </span>
                          </AlignItens>
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </ItemCard>
            </>
          </Card>
        </CardTypeLeft>
        <CardTypeRight>
          <Card.Header style={CardHeader}>Data de carregamento</Card.Header>
          <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', boxShadow: '0px 2px 4px #00000033' }}>
            <>
              <ItemCard>
                <img src={CalendarIcon} alt="Ícone de data de pedido"/>
                <Datepicker 
                  setLoadingConfirm={setLoadingConfirm} 
                  loadingConfirm={loadingConfirm}   
                  margin={"0rem 0.75rem 1.3rem .7rem"}
                />
              </ItemCard>
            </>
          </Card>
        </CardTypeRight>
      </ContainerType>
    </div>
  );
}
